import React from 'react';
import { getSettings } from '../../util/getSettings';
import classnames from 'classnames';
import { QsStateManager } from '../../util/urls';

const CityFilter = () => {
  const settings = getSettings(['century', 'settings']);
  const cities = settings.metroName.length ? settings.cities.filter((city) => city.MetroName === settings.metroName) : settings.cities
  const searchString = new QsStateManager().getSearchString();

  return (
    <div className="metroFilter">
      {cities.map((city, idx) =>
        <a 
          key={idx} 
          href={searchString.length ? city.RelativeURL + searchString : city.RelativeURL}
          className={classnames('metro-link', {'selected': settings.cityName.includes(city.CityName)})}
        >
          {city.CityName}
        </a>
      )}
    </div>
    );
};

export default CityFilter;